import React, { useState, useEffect, useMemo } from "react";
import { Table, Tag, Card, Button, Space, Form, Input, Switch, Select, Col, Row } from 'antd';
import XLSX from 'xlsx'
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import { useNavigate } from "react-router-dom";
import InsuranceDetails from "../shared/insuranceDetails/InsuranceDetails";
import { ZoomInOutlined } from "@ant-design/icons";
import { usePersistedStore } from "../../store/persisted-store";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../store/slices/createReportsSlice";


export default function BusinessSupport() {
    const reports = useReportsStore()
    const general = useGeneralStore();
    const { auth, business } = usePersistedStore();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const data = reports.support.filtered;
    const loading = reports.support.loading;
    const currentBusiness = business.currentBusiness;
    const userInfoResources = auth.userInfo.Resources;
    const [requestId, setRequestId] = useState();
    const [filterData, setFilterData] = useState([]);
    const [statusTitleInfo, setStatusTitleInfo] = useState(false);
    const [, setLoad] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const InsuranceTypeNameFilter = [...new Set(data.map(item => item.InsuranceTypeName))];
    const CompanyNameFilter = [...new Set(data.map(item => item.CompanyName))];

    const cachedStatuses = useMemo(() => {
        const cachedStatuses = [];
        data?.forEach(d => {
            // !cachedStatuses.includes("صادر شده") && cachedStatuses.push("صادر شده")
            if (!cachedStatuses.includes(d.StatusTitle)) {
                cachedStatuses.push(d.StatusTitle);
            }
        })
        return cachedStatuses
    }, [data]);

    const columns = [
        {
            title: "جزئیات بیمه نامه",
            dataIndex: "operation",
            key: "operation",
            width: 85,
            render: (_, record) =>
                data.length >= 1 && (
                    <Space size="middle">
                        <Button type='link' onClick={() => {
                            reports.getInsuranceDetailsInfo(record.InsuranceRequestId)
                            setRequestId(record.InsuranceRequestId);
                            general.ToggleInsuranceDetailsModal();
                        }
                        }><ZoomInOutlined /></Button>
                    </Space>
                ),
        },
        {
            title: 'شناسه',
            width: 200,
            dataIndex: 'InsuranceRequestId',
            key: 'InsuranceRequestId',
            filters: [{
                text: 'London',
                value: 'London',
            },],
            filterSearch: true,
            onFilter: (value, record) => {
                record.InsuranceRequestId.includes(value)
            },
        },
        {
            title: 'نام',
            dataIndex: 'FullName',
            key: 'FullName',
            width: 170,
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.FullName ? first = a.FullName : first = '';
                b.FullName ? second = b.FullName : second = '';
                return first.localeCompare(second)
            },
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
        },
        {
            title: 'نام کاربری',
            dataIndex: 'UserName',
            width: 170,
            key: 'UserName',
            render: text => strings.getFarsiNum(text),
        },
        {
            title: 'رشته',
            dataIndex: 'InsuranceTypeName',
            width: 170,
            key: 'InsuranceTypeName',
        },
        {
            title: 'شرکت',
            dataIndex: 'CompanyName',
            width: 170,
            key: 'CompanyName',
        },
        {
            title: 'وضعیت',
            dataIndex: 'StatusTitle',
            width: 170,
            key: 'StatusTitle',
            render: text => {
                if (text === 'رد شده') {
                    return <Tag color="#ff4a4a">{text}</Tag>
                } else if (text === 'تکمیل اطلاعات') {
                    return <Tag color="#008ee4">{text}</Tag>
                } else {
                    return <Tag color="#5ec393">{text}</Tag>
                }
            }
        },
        {
            title: 'تاریخ ایجاد درخواست',
            dataIndex: 'CreationTime',
            width: 170,
            key: 'CreationTime',
            sorter: (a, b) => new Date(a.CreationTime) - new Date(b.CreationTime),
            render: date => date && strings.getFarsiNum(moment(date).format('jYYYY/jMM/jDD HH:mm'))
        },
        {
            title: 'مبلغ کل',
            dataIndex: 'SummarizeAmount',
            width: 170,
            key: 'SummarizeAmount',
            render: data => strings.currencyFormat(data)
        },
        {
            title: 'مبلغ پرداختی',
            dataIndex: 'Payment',
            width: 170,
            key: 'Payment',
            render: data => strings.currencyFormat(data)
        },
        {
            title: 'مابه التفاوت',
            dataIndex: 'DebtorAmount',
            width: 170,
            key: 'DebtorAmount',
            render: data => strings.currencyFormat(data)
        },
        {
            title: "روش پرداخت",
            dataIndex: "Installment",
            key: "Installment",
            width: 80,
            render: data => data ? 'اقساطی' : 'نقدی'
        },
        {
            title: 'مدت بیمه نامه',
            dataIndex: 'DurationTitle',
            width: 170,
            key: 'DurationTitle'
        },
        {
            title: 'تاریخ تحویل انتخابی',
            dataIndex: 'DeliveryDate',
            width: 170,
            key: 'DeliveryDate',
            render: date => date && strings.getFarsiNum(moment(date).format('jYYYY/jMM/jDD'))
        },
        {
            title: 'زمان تحویل انتخابی',
            dataIndex: 'DeliveryTimeTypeId',
            width: 170,
            key: 'DeliveryTimeTypeId',
            render: id => {
                if (id === 1) {
                    return 'قبل از ظهر'
                } else {
                    return 'بعد از ظهر'
                }
            }
        },
        {
            title: 'درگاه بانکی',
            dataIndex: 'GatewayTitle',
            width: 170,
            key: 'GatewayTitle',
            render: text => text && text.replace('درگاه ', '')
        },
        {
            title: 'کد رهگیری',
            dataIndex: 'TrackingCode',
            width: 170,
            key: 'TrackingCode',
            render: text => text && text.toUpperCase().replace('BM-', '')
        },
        {
            title: 'تاریخ پرداخت',
            dataIndex: 'BuyDate',
            width: 250,
            key: 'BuyDate',
            render: date => date && strings.getFarsiNum(moment(date).format('jYYYY/jMM/jDD HH:mm'))
        }
    ]

    const { token } = currentBusiness;

    function handlePaste(event) {
        let paste = (event.clipboardData || window.clipboardData).getData("text");
        paste = paste.split("|").join(",");
        setSearchValue(paste)
    }

    useEffect(() => {
        if (!token)
            navigate('/dashboard');
        reports.getSupport();
    }, [navigate, token])

    useEffect(() => {
        setFilterData(data)
    }, [data]);

    useEffect(() => {
        if (searchValue === "") return setFilterData(data)
    }, [searchValue]);

    const handleDataChange = statusTitleInfo => {
        form.setFieldsValue({ company: null });
        form.setFieldsValue({ branch: null });
        if (statusTitleInfo) {
            form.setFieldsValue({ info: ["صادر شده"] });
            const information = filterData.filter(row => row.StatusTitle === "صادر شده");
            setFilterData(information)

        } else {
            form.setFieldsValue({ info: [] });
            setFilterData(data)
        }
        setStatusTitleInfo(statusTitleInfo);
    };

    const insuranceNameFilter = nameSearch => {
        setStatusTitleInfo(false)
        form.setFieldsValue({ company: null });
        if (nameSearch === null) {
            setFilterData(data)
        } else {
            const insuranceName = data.filter(insuranceType =>
                insuranceType.InsuranceTypeName.includes(nameSearch))
            setFilterData(insuranceName)
        }

    };

    const companyFilter = company => {
        setStatusTitleInfo(false)
        form.setFieldsValue({ branch: null });
        if (company === null) {
            setFilterData(data)
        } else {
            const companyTypeName = data.filter(CompanyType =>
                CompanyType.CompanyName.includes(company))
            setFilterData(companyTypeName)
        }
    };

    const statusTitleFilter = statusTitles => {
        setStatusTitleInfo(false)
        form.setFieldsValue({ company: null });
        form.setFieldsValue({ branch: null });
        if (!statusTitles || statusTitles.length === 0) {
            setFilterData(data)
        } else {
            const statusTitleInfo = data.filter(item =>
                statusTitles.some(status => item.StatusTitle.includes(status)))
            setFilterData(statusTitleInfo)
        }
    };

    const searchHandlerInput = (event) => {
        const { value } = event.target;
        setSearchValue(value);
        if (value) {
            const filtered = data && data.filter((item) => {
                return item.FullName.includes(value) ||
                    item.UserName.includes(value) ||
                    item.InsuranceRequestId.toString().includes(value) ||
                    item.InsuranceTypeName.includes(value) || item.CompanyName.includes(value) ||
                    item.TrackingCode.includes(Number(value))
            }
            )
            if (filtered) setFilterData(filtered)
        }
    }

    function downloadxlsx() {
        let evaluator = filterData ? filterData : data;
        if (!data) return
        let xlsxData = evaluator?.map(d => {
            return [
                d.InsuranceRequestId,
                d.FullName,
                d.UserName,
                d.InsuranceTypeName,
                d.CompanyName,
                d.StatusTitle,
                d?.CreationTime ? strings.getFarsiNum(moment(d.CreationTime).format('jYYYY/jMM/jDD HH:mm')) : "",
                d.SummarizeAmount,
                d.Payment,
                d.DebtorAmount,
                !d.Installment ? 'نقدی' : 'اقساطی',
                d.DurationTitle,
                d?.DeliveryDate && strings.getFarsiNum(moment(d.DeliveryDate).format('jYYYY/jMM/jDD')),
                d.DeliveryTimeTypeId === 1 ? "قبل از ظهر" : "بعد از ظهر",
                d?.GatewayTitle ? d.GatewayTitle.replace("درگاه", "") : "",
                d?.TrackingCode?.toUpperCase().replace('BM-', ''),
                d.BuyDate ? strings.getFarsiNum(moment(d.BuyDate).format('jYYYY/jMM/jDD HH:mm')) : ""               // moment(d.BuyDate).format('jYYYY/jMM/jDD')
            ]
        }
        );
        xlsxData.unshift(['شناسه', "نام", ' نام کاربری', 'رشته', "شرکت", 'وضعیت', 'تاریخ ایجاد درخواست', 'مبلغ کل', 'مبلغ پرداختی', 'مابه‌التفاوت', 'روش پرداخت', 'مدت بیمه‌نامه', 'تاریخ تحویل انتخابی', 'زمان تحویل انتخابی', 'درگاه بانکی', "کد رهگیری", "تاریخ پرداخت"])
        const worksheet = XLSX.utils.aoa_to_sheet(xlsxData);
        const new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");
        XLSX.writeFile(new_workbook, "businessSupportReport.xlsx")
    }

    function onfinish(values) {
        setLoad(true);
        let { branch, search, company, info } = values;
        if (info) info = "تکمیل اطلاعات"

        let array = [];
        const filtered = data && data.filter((item, index) => {
            // quering for search input field
            if ((search ? item.FullName.includes(search) ||
                item.UserName.includes(search) ||
                item.InsuranceRequestId.toString().includes(search) ||
                item.InsuranceTypeName.includes(search) || item.CompanyName.includes(search) ||
                item.TrackingCode.includes(Number(search)) : true)

                && (company ? item.CompanyName.includes(company) : true)
                && (branch ? item.InsuranceTypeName.includes(branch) : true)
                && (info ? item.StatusTitle == info : true)) {
                array.push(item);
                return array
            }
        })
        if (filtered) setFilterData(filtered)
        setLoad(false);
    }


    return (
        <Card>
            <div className="alert alert-warning alert-dismissible fade show" role="alert" style={{ padding: "15px" }}>
                <i className="mdi mdi-alert-outline mr-2"></i> اطلاعات ذیل مربوط به پانزده روز گذشته می باشند.
                <div style={{ float: "left" }}>
                    <button
                        style={{ position: "relative", bottom: 6, }}
                        type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit"
                        onClick={() => {
                            reports.getSupport()
                            form.resetFields();
                        }}>
                        بروزرسانی لیست &nbsp;&nbsp;&nbsp;<i className={loading ? "bx bx-loader bx-spin" : "fas fa-sync-alt"}></i>
                    </button>
                </div>
            </div>
            <div dir="rtl">

            </div>
            <Form
                form={form}
                onFinish={onfinish}
                layout="inline"
                className="components-table-demo-control-bar"
                style={{ marginBottom: 16 }}
            >
                <Row gutter={[8, 16]} justify="space-between" align="middle">

                    <Col xs={6}>

                        <Form.Item
                            label="فیلتر بر اساس رشته"
                            name="branch">
                            <Select
                                onChange={insuranceNameFilter}
                                defaultValue={null}
                                className="BusinessSupport-filter"
                                placeholder="نوع بیمه">
                                <Select.Option value={null} >همه رشته  بیمه ها</Select.Option>
                                {InsuranceTypeNameFilter.length && InsuranceTypeNameFilter.map((name, index) => {
                                    return <Select.Option key={index} value={name}>{name}</Select.Option>
                                })}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={6}>
                        <Form.Item
                            label={<>فیلتر بر اساس شرکت</>}
                            name="company">
                            <Select
                                defaultValue={null}
                                className="BusinessSupport-filter"
                                onChange={companyFilter}
                                placeholder="نام شرکت">
                                <Select.Option value={null}>همه شرکت ها</Select.Option>
                                {CompanyNameFilter.length && CompanyNameFilter.map((name, index) => {
                                    return <Select.Option key={index} value={name}>{name}</Select.Option>
                                })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col xs={6}>
                        <Form.Item name="info" label="فیلتر بر اساس وضعیت">
                            <Select
                                mode="multiple"
                                className="BusinessSupport-filter"
                                onChange={statusTitleFilter}
                                placeholder="وضعیت">
                                {cachedStatuses?.map((status) => <Select.Option key={status} value={status}>{status}</Select.Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col className="d-flex align-items-center" xs={6}>

                        <Form.Item name="showIssuedOnly" label="نمایش فقط صادر شده">
                            <Switch defaultChecked={false} checked={statusTitleInfo}
                                onChange={handleDataChange}
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={20}>
                        <Form.Item
                            onKeyPress={(e) => (e.key === 'Enter' && "")}
                            name="search" label="فیلتر بر اساس نام، نام کاربری ، رشته ، شرکت، کد رهگیری ">
                            <Input
                                value={searchValue}
                                onPaste={handlePaste}
                                onChange={e => searchHandlerInput(e)}
                                className="table-search"
                                placeholder=" جستجو بر اساس شناسه، نام، نام کاربری ، رشته ، شرکت، کد رهگیری"
                            />
                        </Form.Item>
                    </Col>

                    <Col style={{ marginRight: "auto", marginLeft: 22 }} xs={3}>
                        <div style={{ whiteSpace: "nowrap" }}>
                            {userInfoResources && userInfoResources?.includes("BusinessAdmin") && <div style={{ cursor: "pointer" }} onClick={downloadxlsx} className="btn-success border-0 rounded ml-auto pb-2 pt-2 pr-3 pl-3 mr-2 mb-2"> <i className="far fa-file-excel font-size-14 align-middle mr-2"></i>دریافت اکسل</div>}

                            {/* <button
                                disabled={load} type="primary" className="btn btn-primary waves-effect waves-light" style={{ marginLeft: 12 }} htmltype="submit">
                                <i className={`${load ? "bx bx-loader bx-spin" : "fas fa-search"} font-size-14 align-middle mr-2`}></i>اعمال فیلتر
                            </button> */}
                        </div>
                    </Col>
                </Row>
            </Form>
            <Table
                style={{ overflowX: 'scroll', width: "100%" }}
                bordered
                dataSource={[...filterData] && [...filterData]}
                loading={loading}
                rowKey="InsuranceRequestId"
                scroll={true}
                columns={userInfoResources &&
                    (userInfoResources.includes("BusinessSaleReport") ||
                        userInfoResources.includes("BusinessSupportReport")) ?
                    columns : (columns.filter(col => col.dataIndex !== 'operation'))}
                className="custom-table"
            />
            <InsuranceDetails requestId={requestId} />
        </Card>
    )
}